import { render, staticRenderFns } from "./DbConnection.vue?vue&type=template&id=7cc1160d"
import script from "./DbConnection.vue?vue&type=script&lang=js"
export * from "./DbConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports